module.exports = __webpack_public_path__ + "static/media/chic.8b01fb25.jpg";